import { render, staticRenderFns } from "./after-sales.vue?vue&type=template&id=7ba23716&scoped=true&"
import script from "./after-sales.vue?vue&type=script&lang=js&"
export * from "./after-sales.vue?vue&type=script&lang=js&"
import style0 from "./after-sales.vue?vue&type=style&index=0&id=7ba23716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba23716",
  null
  
)

export default component.exports